import HTTP from "../HTTP";
import Jsona from "jsona";

const dataFormatter = new Jsona();

export default {
  async index(number_page, field_sort, text_search) {
    try {
      let search = "";
      let page = `&page[number]=${number_page}&page[size]=30`;
      let sort = "";

      if (text_search.length >= 3)
        search = `&filter[display_name]=${text_search}&filter[active]=true`;

      let results = await HTTP.normal.get(
        `/cities?include=districts,state,state.country${search}${page}${sort}`
      );

      return {
        data: dataFormatter.deserialize(results.data),
        meta: results.data.meta
      };
    } catch (e) {
      throw "Ocorreu um erro ao listar as cidades!";
    }
  },

  async listAll() {
    try {
      let results = await HTTP.normal.get(
        "/cities?include=districts,state,state.country&filter[active]=true"
      );
      return dataFormatter.deserialize(results.data);
    } catch (e) {
      throw "Ocorreu um erro ao listar as cidades!";
    }
  },

  async districts(city_id) {
    try {
      let results = await HTTP.normal.get(
        `/cities/${city_id}/districts?include=rating,pricing`
      );
      return dataFormatter.deserialize(results.data);
    } catch (e) {
      throw "Ocorreu um erro ao listar os distritos pela cidade selecionada!";
    }
  },

  async searchByName(query, active = null) {
    let activeFilter = active === null ? "" : `&filter[active]=${active}`;
    try {
      let results = await HTTP.normal.get(
        `/cities?filter[display_name]=${query}${activeFilter}&include=districts.rating,districts.pricing,state`
      );
      return dataFormatter.deserialize(results.data);
    } catch (e) {
      throw "Ocorreu um erro ao buscar as cidades pelo nome!";
    }
  },

  async create(payload) {
    let data = {
      type: "cities",
      display_name: payload.display_name,
      code: payload.code,
      state: {
        type: "states",
        id: payload.state_id
      },
      relationshipNames: ["state"]
    };

    data = dataFormatter.serialize({
      stuff: data
    });

    try {
      await HTTP.normal.post("/cities", data);
    } catch (e) {
      var error = [];

      e.response.data.forEach(el => {
        if (el.title === "has already been taken") {
          error.push({
            field: el.detail.split(" ")[0],
            msg: "já está sendo usado"
          });
        }
      });

      throw error;
    }
  }
};



// WEBPACK FOOTER //
// ./src/API/modules/cities.js